import { parsePolicyText } from '@repo/common';

const TEXT = `오잉랩(브랜드명 "코레디", 이하 "회사")은 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 관련 고충을 신속·원활하게 처리하기 위하여 본 개인정보처리방침을 수립·공개합니다. 회사는 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 준수합니다.

## 제1조(개인정보의 처리 목적 및 처리 근거)
① 회사는 다음의 목적을 위하여 개인정보를 처리하며, 각 수집 항목별 처리 근거는 「개인정보 보호법」 제15조 제1항 각 호에 따라 아래와 같이 정합니다.
| 수집 항목 | 처리 목적 | 처리 근거 |
| --- | --- | --- |
| 이메일, 이름, 거주 국가·도시, 생년월일 | 회원가입 및 계정 관리, 서비스 제공 | 계약의 이행(제4호) 또는 동의(제1호) |
| 성별(선택) | 서비스 개선·통계 | 동의(제1호) |
| 프로필 사진(선택) | 계정 프로필 표시 | 동의(제1호) |
| 결제정보(수단·통화·거래ID 등) | 결제·환불 처리 | 계약의 이행(제4호), 법적 의무(제2호) |
| 전화번호, 학업·경력 정보(선택) | 커리어·정착 지원(Pathfinder 등) | 동의(제1호) |
| 접속기록·쿠키·분석데이터 | 서비스 개선, 부정이용 방지 | 정당한 이익(제6호) 또는 동의(제1호) |
| 이름, 연락처, 이메일 | 고객의 신원 확인, 민원사항 확인, 사실 조사를 위한 연락 및 통지, 처리결과 통보 및 고객 문의/상담 | 계약의 이행(제4호) 또는 동의(제1호)<br>소비자 불만·분쟁 처리 기록은 법적 의무(제2호) |
| [필수]<br>기본정보(이름, 생년월일, 성별, 이메일, 휴대폰, 주소), 경력사항(회사명, 직무, 입사일, 퇴사일), 비자정보(체류자격, 비자발급일, 입국만료일)<br><br>[선택]<br>사진, 포트폴리오, 기타문서(파일), 경력 고용형태 및 위치, 경력 내 세부 성취 활동, 경력 기간, 한국어 이름, TOPIK 및 어학 자격증, 교육이수 및 대외활동, 학력사항(학위, 학교명, 전공, 입학일, 졸업일) | 이력서 등록을 통한 입사지원 서비스 | 동의(제1호)<br>지원 절차 진행은 계약의 이행(제4호)<br>기업회원 제공은 별도 동의(법 제17조, 제6조의2) |

② 회사는 정당한 이익을 근거로 처리하는 경우 그 이익이 정보주체의 권리보다 우선함이 명백한 범위에서만 처리합니다.

③ 이용자는 동의를 근거로 처리되는 항목에 대하여 동의를 거부할 수 있습니다. 다만 해당 항목의 동의를 거부하는 경우 관련 서비스(이력서 등록·입사지원, 커리어·정착 지원 등)의 이용이 제한될 수 있으며, 회원가입 및 기본 서비스 이용에는 영향을 주지 않습니다.

## 제2조(수집하는 개인정보의 항목)
① (필수) 이메일, 이름, 거주 국가 및 도시, 생년월일

② (선택) 성별, 프로필 사진, 전화번호, 업무·학업 경험, 학습·워크숍 참여 정보

③ (결제 시) 결제 수단 및 통화, 결제 금액·상태·일자, 환불 상태, 결제 승인번호 또는 거래ID(PayPal 거래ID 포함)

④ (Pathfinder 이용 시) 이용자가 직접 입력하는 현재 거주 국가·도시 및 학교명·학교 소재지. 회사는 GPS·기기 위치 API 등 자동 위치추적을 사용하지 않습니다.

⑤ (자동수집) 기기·브라우저 종류, 방문 페이지 및 이동경로, 대략적 지역(정확한 위치 아님), 접속시간·오류 등 로그

## 제2조의2(이력서 등록 및 입사지원 시 수집 항목)
① (필수) 기본정보(이름, 생년월일, 성별, 이메일, 휴대폰, 주소), 경력사항(회사명, 직무, 입사일, 퇴사일), 비자정보(체류자격, 비자발급일, 입국만료일)

② (선택) 사진, 포트폴리오, 기타문서(파일), 경력 고용형태 및 위치, 경력 내 세부 성취 활동, 경력 기간, 한국어 이름, TOPIK 및 어학 자격증, 교육이수 및 대외활동, 학력사항(학위, 학교명, 전공, 입학일, 졸업일)

③ 이력서에 포함된 개인정보는 이용자가 채용공고에 지원하는 경우에 한하여 제6조의2에 따라 기업회원에게 제공됩니다.

## 제3조(개인정보의 수집 방법)
회사는 회원가입, 서비스 이용, 결제, 문의·상담, 이벤트 응모 및 웹사이트 이용 과정에서 정보주체가 직접 입력하거나 자동수집장치(쿠키 등)를 통하여 개인정보를 수집합니다.

## 제4조(개인정보의 처리 및 보유기간)
① 회사는 원칙적으로 처리 목적이 달성되거나 회원 탈퇴 시 지체 없이 개인정보를 파기합니다. 다만 관련 법령에 따라 다음의 정보는 정해진 기간 동안 보관합니다.
| 보존 항목 | 보존 기간 | 근거 법령 |
| --- | --- | --- |
| 계약 또는 청약철회 등에 관한 기록 | 5년 | 전자상거래법 시행령 제6조 |
| 대금결제 및 재화등의 공급에 관한 기록 | 5년 | 전자상거래법 시행령 제6조 |
| 소비자 불만 또는 분쟁처리에 관한 기록 | 3년 | 전자상거래법 시행령 제6조 |
| 표시·광고에 관한 기록 | 6개월 | 전자상거래법 시행령 제6조 |
| 웹사이트 접속기록(로그) | 3개월 이상 | 통신비밀보호법, 안전성 확보조치 기준 |

② 계정 삭제 후에도 법령상 보관 의무가 있는 정보는 다른 개인정보와 분리하여 보관하며, 법령에서 정한 목적 외로 이용하지 않습니다.

## 제4조의2(이력서 및 입사지원 정보의 보유기간)
① 이력서 정보는 회원 탈퇴 시 또는 이용자가 이력서를 삭제한 때 지체 없이 파기합니다.

② 입사지원 내역은 회원 탈퇴 시까지 보유하며, 탈퇴 시 지체 없이 파기합니다. 다만 제4조 제1항의 법령상 보존 대상에 해당하는 기록은 해당 기간 동안 보관합니다.

③ 기업회원에게 제공된 이력서 및 제출 서류에 대한 기업회원의 열람 권한 종료 기준은 제6조의2에서 정합니다.

## 제5조(만 18세 미만 및 아동의 개인정보)
① 서비스는 만 18세 이상을 대상으로 하며, 회사는 회원가입 시 생년월일 확인을 통하여 만 18세 미만의 가입을 제한합니다.

② 회사는 「개인정보 보호법」 제22조의2에 따라 만 14세 미만 아동의 개인정보를 원칙적으로 수집하지 않으며, 부득이 수집이 필요한 경우 법정대리인의 동의를 받습니다. 만 14세 미만 아동이 법정대리인 동의 없이 가입한 사실을 알게 된 경우 지체 없이 해당 정보를 파기합니다.

## 제6조(개인정보의 제3자 제공)
① 회사는 정보주체의 개인정보를 제1조의 목적 범위에서만 처리하며, 「개인정보 보호법」 제17조·제18조에 따라 정보주체의 동의가 있거나 법령에 근거가 있는 경우에 한하여 제3자에게 제공합니다.

② 제3자에게 제공하는 경우 회사는 제공받는 자, 제공 목적, 제공 항목, 제공받는 자의 보유·이용기간을 정보주체에게 알리고 동의를 받습니다.

## 제6조의2(입사지원에 따른 개인정보의 제3자 제공)
① 회사는 이용자가 채용공고에 지원하는 경우에 한하여 아래와 같이 개인정보를 기업회원에게 제공합니다.
| 제공받는 자 | 제공 목적 | 제공 항목 | 보유 및 이용기간 |
| --- | --- | --- | --- |
| 이용자가 지원한 채용공고를 등록한 기업회원 | 채용 절차 진행 및 지원자와의 연락 | 이력서 및 제출 서류에 포함된 개인정보 항목과 첨부파일 | 최종 합격 시: 공식 입사일부터 90일<br>불합격 시: 해당 채용 절차 종료 시 |

② 회사는 이용자의 지원 없이 기업회원에게 이력서를 제공하거나 열람하게 하지 않으며, 기업회원이 이력서를 검색할 수 있는 기능을 제공하지 않습니다.

③ 회사는 지원 화면에서 제1항의 제공 내용을 명확히 표시하고 이용자의 동의를 받으며, 동의하지 않는 경우 지원이 진행되지 않습니다.

④ 회사는 제1항의 보유 및 이용기간이 지나면 해당 기업회원의 열람 권한을 자동으로 만료처리하며, 기업회원은 그 이후 해당 정보를 채용 목적으로 보유할 수 없습니다.

⑤ 이용자는 채용 절차가 진행 중인 경우에도 지원을 철회하거나 제1항의 제공에 대한 동의를 철회할 수 있으며, 이 경우 회사는 해당 기업회원의 열람 권한을 지체 없이 종료합니다. 다만 이미 제공된 개인정보의 파기는 해당 기업회원의 개인정보 처리 기준과 관련 법령에 따릅니다.

## 제7조(개인정보 처리의 위탁)
① 회사는 서비스 제공을 위하여 아래와 같이 개인정보 처리업무를 위탁하고 있으며, 「개인정보 보호법」 제26조에 따라 위탁 사실을 공개하고 수탁자를 관리·감독합니다.
| 수탁자 | 위탁 업무 | 비고 |
| --- | --- | --- |
| Amazon Web Services | 클라우드 호스팅·데이터 보관 | 서울 지역 |
| Toss Payments, PayPal | 결제·환불 처리 | PayPal은 국외 처리(제8조) |
| Google (Google Meet) | 온라인 라이브 세션 운영 | 국외 처리(제8조) |
| Google (Analytics 4), Microsoft (Clarity) | 서비스 이용 분석·개선 | 국외 처리(제8조) |

② 회사는 위탁계약 시 개인정보의 목적 외 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 관리·감독 및 손해배상 등에 관한 사항을 정하고 정기적으로 관리·감독합니다. 수탁자 또는 위탁업무의 내용이 변경되는 경우 지체 없이 본 방침을 통하여 공개합니다.

## 제8조(개인정보의 국외 이전)
① 회사의 서버(AWS)는 대한민국(서울 리전)에 위치합니다. 다만 아래 수탁자를 통하여 개인정보가 국외에서 처리될 수 있으며, 회사는 「개인정보 보호법」 제28조의8에 따라 그 사실을 공개하고 필요한 경우 정보주체의 동의를 받거나 법정 요건을 갖춥니다.
| 이전받는 자 | 이전 국가 | 이전 항목 | 이전 목적·보유기간 |
| --- | --- | --- | --- |
| Google LLC | 미국 등 | 접속·이용 분석데이터, 세션 이용정보 | 서비스 분석·라이브 세션 제공 /<br>각 서비스 정책에 따름 |
| Microsoft Corp. | 미국 등 | 이용행태 분석데이터 | 사용성 개선 / 각 서비스 정책에 따름 |
| PayPal | 미국 등 | 결제 관련 정보 | 해외 결제 처리 / 각 서비스 정책에 따름 |

② 각 수탁자의 정확한 이전 국가, 이전 일시·방법, 보유기간은 계약 및 서비스 설정에 따라 확정하여 본 방침에 반영하시길 바랍니다.

## 제9조(쿠키 등 자동수집장치의 설치·운영 및 거부)
① 회사는 서비스 운영 및 이용현황 분석을 위하여 쿠키를 사용하며, Google Analytics 4 및 Microsoft Clarity를 통하여 이용행태 데이터를 수집할 수 있습니다.

② 이용자는 브라우저 설정을 통하여 쿠키 저장을 거부할 수 있으며, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.

③ 회사는 분석 도구를 통한 행태정보 수집에 대하여 이용자가 동의 여부를 선택할 수 있도록 쿠키 동의 배너 등 동의 절차를 마련합니다.

## 제10조(정보주체의 권리·의무 및 행사방법)
① 정보주체는 회사에 대하여 언제든지 개인정보 열람, 정정·삭제, 처리정지 및 동의 철회를 요구할 수 있습니다.

② 회사는 열람 요구를 받은 날부터 10일 이내에 열람 여부를 결정하여 통지하며, 정정·삭제(제36조) 및 처리정지(제37조) 요구에 대하여도 관련 법령이 정한 기간 내에 조치합니다.

③ 권리 행사는 contact@ko-ready.com 또는 설정 > 계정 삭제를 통하여 할 수 있으며, 회사는 본인 확인 절차를 거친 후 조치합니다. 대리인을 통한 경우 위임장을 제출받습니다.

## 제11조(개인정보의 파기절차 및 방법)
① 회사는 보유기간이 경과하거나 처리 목적이 달성된 개인정보를 선정하여 지체 없이 파기합니다.

② 전자적 파일은 복구·재생할 수 없는 기술적 방법으로 삭제하고, 종이 문서는 분쇄하거나 소각하여 파기합니다.

## 제12조(개인정보의 안전성 확보조치)
회사는 「개인정보 보호법」 제29조에 따라 다음의 조치를 취합니다: 내부관리계획 수립·시행, 개인정보 접근권한의 관리 및 접근통제, 개인정보의 암호화, 접속기록의 보관 및 위·변조 방지, 개인정보취급자 교육 등.

## 제13조(개인정보 보호책임자)
① 회사는 개인정보 처리에 관한 업무를 총괄하고 정보주체의 고충을 처리하기 위하여 개인정보 보호책임자를 지정합니다.

② 개인정보 보호책임자: 권하연 / 연락처: contact@ko-ready.com

## 제14조(권익침해 구제방법)
정보주체는 아래 기관에 개인정보 침해에 관한 분쟁 해결이나 상담을 신청할 수 있습니다.
· 개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)
· 개인정보침해신고센터: (국번 없이) 118 (privacy.kisa.or.kr)
· 대검찰청 사이버수사과: 1301 / 경찰청 사이버수사국: 182

## 제15조(개인정보처리방침의 변경)
이 방침은 법령·서비스의 변경에 따라 개정될 수 있으며, 회사는 변경 내용이 이용자에게 불리한 경우 적용일 30일 전부터, 그 외의 경우 적용일 7일 전부터 이메일 또는 사이트 공지를 통하여 안내합니다.

코레디 (Koready) | contact@ko-ready.com | 개인정보 보호책임자: 권하연`;

/** 정책 문서 한 버전(국문). 노션 Policy Hub 「Koready 개인정보처리방침 (개인회원)」 원문. */
export default {
  lang: 'ko',
  title: '개인정보처리방침',
  lastUpdated: '2026년 8월 28일',
  lastUpdatedLabel: '시행일',
  effectiveDate: '2026-08-28',
  sections: parsePolicyText(TEXT),
};
